import React, { useEffect, useState, Fragment } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
interface HeaderProps {
  onOpenQuote: () => void;
}
export function Header({
  onOpenQuote
}: HeaderProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Hide header when at the very top of the home page to let Hero branding take over
  if (isHome && !isScrolled) return null;
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Services',
    path: '/services'
  }, {
    name: 'Menu',
    path: '/menu'
  }, {
    name: 'Events',
    path: '/events'
  }, {
    name: 'Story',
    path: '/story'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white/95 backdrop-blur-md shadow-sm py-3 md:py-4" data-id="element-156">
      <div className="max-w-[1800px] mx-auto px-4 md:px-8 flex items-center justify-between" data-id="element-157">
        <div className="flex items-center w-1/2 xl:w-1/4" data-id="element-158">
          <Link to="/" data-id="element-159">
            <img src="https://cdn.magicpatterns.com/uploads/otjuHu8XNsL2f4dQ3LfjEG/ChatGPT_Image_Apr_22,_2026,_03_42_32_PM.png" alt="Versatile LLC Cater 2 U" className="h-12 md:h-20 w-auto object-contain transition-all" data-id="element-160" />
          </Link>
        </div>

        {/* Desktop Nav - Better Spacing */}
        <nav className="hidden xl:flex items-center justify-center gap-12 flex-grow" data-id="element-161">
          {navLinks.map(link => {
          const isActive = location.pathname === link.path || link.path !== '/' && location.pathname.startsWith(link.path);
          return <Link key={link.name} to={link.path} className={`text-[13px] font-serif font-bold uppercase tracking-[0.15em] transition-colors text-center leading-tight ${isActive ? 'text-brand-gold' : 'text-brand-black hover:text-brand-gold'}`} data-id="element-162">
                {link.name.split(' ').map((word, i) => <Fragment key={i} data-id="element-163">
                    {word}
                    {i === 0 && link.name.includes(' ') && <br data-id="element-164" />}
                  </Fragment>)}
              </Link>;
        })}
        </nav>

        <div className="hidden xl:flex justify-end w-1/4" data-id="element-165">
          <button onClick={onOpenQuote} className="bg-brand-gold text-white px-10 py-6 rounded-sm text-sm font-bold uppercase tracking-widest hover:bg-brand-black transition-all duration-300 shadow-xl leading-tight text-center" data-id="element-166">
            Request a Custom <br data-id="element-167" /> Quote
          </button>
        </div>

        {/* Mobile Toggle */}
        <button className="xl:hidden text-brand-black p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-168">
          {isMobileMenuOpen ? <X size={28} data-id="element-169" /> : <Menu size={28} data-id="element-170" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="xl:hidden absolute top-full left-0 right-0 bg-white border-t border-gray-100 p-6 flex flex-col gap-4 shadow-xl" data-id="element-171">
          {navLinks.map(link => {
        const isActive = location.pathname === link.path || link.path !== '/' && location.pathname.startsWith(link.path);
        return <Link key={link.name} to={link.path} className={`text-lg font-serif py-2 border-b border-gray-50 ${isActive ? 'text-brand-gold font-bold' : 'text-brand-black hover:text-brand-gold'}`} onClick={() => setIsMobileMenuOpen(false)} data-id="element-172">
                {link.name}
              </Link>;
      })}
          <button onClick={() => {
        onOpenQuote();
        setIsMobileMenuOpen(false);
      }} className="bg-brand-gold text-white px-6 py-4 rounded-sm text-sm font-bold uppercase tracking-widest mt-4" data-id="element-173">
            Request a Custom Quote
          </button>
        </div>}
    </header>;
}